import React, {
  useState,
  useEffect,
  useMemo,
  memo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import * as dateFns from "date-fns";

import { useHistory } from "react-router-dom";

import { Container, Row, Col, TabContent, TabPane, Button } from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// --> 1/4 of the screen
import QueueAttendance from "./components/QueueAttendance/index";

// Custom methods
import {
  objLength,
  isObject,
  isArray,
  findLast,
} from "../../Libs/CustomMethods/customMethods";

//Redux
import { useSelector, useDispatch } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//funcitons
import {
  showToast,
  isAllowedUserMsg,
  isPrivateMsg,
  isValidMsg,
  isSameSender,
  handleTimer,
} from "./functions/utils";

import {
  checkMessages,
  handleSLA,
  updateChangeStatus,
  setActiveChatByChatId,
  handleFilter,
  defaultMsg,
} from "./functions/chat";

// actions
import {
  getConsumerConversations,
  getMessages,
  uploadFile,
  sendMessage,
  setMessage,
  resetStatus,
  resetConsumerStatus,
  resetObj,
  startObserver,
  removeScrollMessage,
} from "../../store/operator/actions";

import { chatCollapsing } from "../../store/layout/actions";

import { getFlashMsgs } from "../../store/flashmessage/actions";

import { getCsat, getNps, setHeaderIndicators } from "../../store/header/actions";

import { changeHeaderName } from "../../store/layout/actions";

import {
  resetClientInfo,
  setCurrentChatData,
} from "../../store/clientInformation/actions";

import { closeObserver } from "../../store/spyChat/actions";

import { vgRemoveMessage } from "../../store/signalr/actions";

import { reopenConversationRes } from "../../store/reopenConversation/actions";
import CommentaryMessageModal from "./components/CommentaryMessageModal/index";
import PrivateMessage from "./components/PrivateMessage/privateMessage";
import ChatTransfer from "./components/ChatTransfer";
import CloseChat from "./components/CloseChat";

import useMessageConversation from "./functions/messageConversantion";
import useCloseConversation from "./functions/closeConversation";
import useTransferConversation from "./functions/transferConversation";
import useMoreConversation from "./functions/moreConversation";
import DisconnectAlert from "./components/DisconnectAlert";
import messagesCheck from "../../Libs/Logs/messagesCheck";
import CreateAttendance from "./components/CreateAttendance";
import { ChatList } from "./ChatList";

import { useTimeoutEffect } from "./hooks/useTimeoutEffect";
import ActionNotAllowedModel from "./components/ActionNotAllowedModel";
import AttendanceComponent from "./components/AttendanceComponent";
import TransferToSkillErroModel from "./components/TransferToSkillErroModel";
import TicketsOperatorArea from "../Common/TicketsOperatorArea";

import toastr from "toastr";

const OperatorArea = ({ t, ...props }) => {
  const { chatExpanded } = useSelector((state) => state.Layout);
  const { data } = useSelector((state) => state.Login);
  const { connSignalR } = useSelector((state) => state.SignalR);
  const { messageOperator, messageConsumer } = useSelector(
    (state) => state.Operator
  );
  const { indicators } = useSelector((state) => state.Header);
  const permissionsExtra =
    useSelector((state) => state.Login?.data?.permissions_extra) || {};

  const userPermissions =
    useSelector((state) => state.Login?.data?.permissions) || [];

  const {
    handleNewMessageQueue,
    handleNewMessageTelegram,
    handleNewMessageFromAgent,
    handleNewMessageFromManager,
    handleNewMessagePrivate,
  } = useMessageConversation();

  const {
    handleClosedByClient,
    handleClosedByAgent,
    handleClosedByManager,
    handleClosedBySystem,
  } = useCloseConversation();

  const {
    handleTransferedByAgent,
    handleTransferedByManager,
    handleTransferedBySystem,
    handleTransferChat,
  } = useTransferConversation();

  const {
    handleInactiveBySystem,
    handleJoinedManager,
    handleEndPreChat,
    handleEndPosChat,
  } = useMoreConversation();

  const spyConversationId = props?.location?.state?.spyConversationId || null;
  const isSpyOperator = props?.location?.state?.isSpyOperator || false;
  const notificationChatId = props?.location?.state?.chatId || null;
  const objFeatureTab = data?.features?.find((e) => e.name === "Tab");

  const { chats: messagesSignalR } = useSelector((state) => state.SignalR);

  const showTicketsOperatorArea = useSelector(
    (state) => state.TicketsOperatorArea.isOpen
  );

  const history = useHistory();
  const dispatch = useDispatch();

  //States
  const [chats, setChats] = useState([]);
  const [triggerSLA, setTriggerSLA] = useState(false);
  const [timer, setTimer] = useState(null);

  const [blockedAction, setBlockedAction] = useState(false);
  const [queueFilter, setQueueFilter] = useState({
    overdue: { active: true, qtd: 0 },
    progress: { active: true, qtd: 0 },
    inactive: { active: true, qtd: 0 },
    closed: { active: false, qtd: 0 },
  });
  const [searchChat, setSearchChat] = useState({
    isSearching: false,
    chats: null,
  });
  const [activeChat, setActiveChat] = useState({
    sendMessage: {
      values: {
        text: null,
      },
      buffer: [],
    },
  });

  const [buffer, setBuffer] = useState({
    queue: [],
  });
  const [sendBuffer, setSendBuffer] = useState([]);

  //TODO: #REF001
  // const [handleConnection, setHandleConnection] = useState({
  //   status: true,
  //   handle: false,
  // });

  const [closeChat, setCloseChat] = useState(false);
  const [tabChat, setTabChat] = useState(false);
  const [createAttendance, setCreateAttendance] = useState(false);
  const [notes, setNotes] = useState(false);
  const [transfChat, setTransfChat] = useState(false);
  const [privateMsg, setPrivateMsg] = useState(false);
  const [commentaryMsg, setCommentaryMsg] = useState(false);

  const [actionType, setActionType] = useState("");

  const [engagementHistory, setEngagementHistory] = useState(false);
  const [skillIdToShowMsg, setSkillIdToShowMsg] = useState("");
  const [showChat, setshowChat] = useState(false);

  const [closedByClient, setClosedByClient] = useState({});
  const [closedByAgent, setClosedByAgent] = useState({});
  const [closedByManager, setClosedByManager] = useState({});
  const [closedBySystem, setClosedBySystem] = useState({});

  const [transferedByAgent, setTransferedByAgent] = useState({});
  const [transferedByManager, setTransferedByManager] = useState({});
  const [transferedBySystem, setTransferedBySystem] = useState({});

  const [inactiveBySystem, setInactiveBySystem] = useState({});
  const [joinedManager, setJoinedManager] = useState(null);
  const [endPreChat, setEndPreChat] = useState(null);
  const [endPosChat, setEndPosChat] = useState(null);
  const [reopenConversation, setReopenConversation] = useState(null);

  const [reconnecting, setReconnecting] = useState(null);

  const [scrollToBottom, setScrollToBottom] = useState(false);
  const [spyConversation, setSpyConversation] = useState(null);
  const [chatImages, setChatImages] = useState();
  const [loadingReconnect, setLoadingReconnect] = useState(false);
  const [updateEngagement, setUpdateEngagement] = useState(null);

  const [messagesErros, setMessagesErrors] = useState([]);
  const [showModalErros, setShowModalErros] = useState(false);

  const handleClickCloseModalRequest = useCallback(() => {
    setShowModalErros(false);
    setMessagesErrors([]);
  }, []);

  const handleClickOpenModalRequest = useCallback(() => {
    setShowModalErros(true);
  }, []);

  const hideEngagementHistoryChannels = useMemo(() => {
    return ["real_automation", "telefone"];
  }, []);

  const hideEngagementHistory = useMemo(() => {
    return !hideEngagementHistoryChannels.includes(
      activeChat?.conversation?.channel
    );
  }, [activeChat, hideEngagementHistoryChannels]);

  const resetActiveChat = () => {
    setActiveChat(() => ({
      sendMessage: {
        values: {
          text: "",
        },
        buffer: [],
      },
    }));
  };

  const userNotAllowed = useCallback(() => {
    if (
      !(
        Array.isArray(userPermissions?.["conversation_download"]) &&
        userPermissions?.["conversation_download"].includes("get")
      )
    ) {
      return true;
    }

    return false;
  }, [userPermissions]);

  const toggleBlockedAction = useCallback(() => {
    setBlockedAction((old) => !old);
  }, []);

  //Download chat in PDF
  const conversationDownload = useCallback(() => {
    if (!userNotAllowed()) {
      let chatId = activeChat?.conversation?.conversationId;
      axios
        .get(`/conversation-download?${chatId ? `&id=${chatId}` : ""}`, {
          method: "GET",
          responseType: "blob", //Force to receive data in a Blob Format
        })
        .then((response) => {
          const file = new Blob([response.data], {
            type: "application/pdf",
          });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch((error) => {
          showToast("error", t("There was an error downloading conversation"));
        });
    } else {
      toggleBlockedAction();
    }
  }, [activeChat, t, toggleBlockedAction, userNotAllowed]);

  const showConversation = (conversation) => {
    if (conversation !== undefined) {
      let status = handleSLA(conversation, getChat);
      switch (status) {
        case "overdue":
          return queueFilter.overdue.active;
        case "normal":
          return queueFilter.progress.active;
        case "bursting":
          return queueFilter.progress.active;
        case "inactive":
          return queueFilter.inactive.active;
        default:
          return queueFilter.closed.active;
      }
    } else {
      return false;
    }
  };

  const getMsgFromBuffer = (pos) => {
    return {
      by: sendBuffer[pos]?.by,
      private: sendBuffer[pos]?.private,
      userId: sendBuffer[pos]?.userId,
      chatId: sendBuffer[pos]?.chatId,
      previousId: sendBuffer[pos]?.previousId,
      message: sendBuffer[pos]?.values,
      sendTime: sendBuffer[pos]?.sendTime,
      status: sendBuffer[pos]?.status,
      countAttempts: sendBuffer[pos]?.countAttempts,
      token: data.Authorization ?? null,
    };
  };

  const addMessage = (type, val) => {
    let values, last;

    if (type === "agentInactivity") {
      values = val;
    } else {
      last = sendBuffer.length - 1;
      values = getMsgFromBuffer(last);
    }
    if (messageOperator?.chats?.data) {
      let aux = messageOperator.chats;
      let pos = "";

      pos =
        aux?.data?.length > 0
          ? aux?.data.find((e) => e.conversationId === values.chatId)
          : null;
      pos = aux?.data?.indexOf(pos);

      // Conversation already exists in the store. So, just insert it
      if (pos !== null && pos !== undefined) {
        let prevFBA = aux.data[pos]?.firstWithoutAnswer; // "First Before Answer" object previously stored

        aux.data[pos] = {
          ...aux.data[pos],
          lastMessage: {
            by: values?.by,
            time: values?.sendTime,
            text: values?.message?.text ?? "",
            files: values?.message?.file
              ? {
                  fileName: values?.message?.file?.fileName,
                  fileUrl: values.message?.file?.fileUrl,
                  thumbUrl: values?.message?.file?.thumbUrl,
                  mimeType: values?.message?.file?.mimeType,
                }
              : null,
            private: values?.private,
          },
          firstWithoutAnswer:
            !isPrivateMsg(values) &&
            isAllowedUserMsg(values) &&
            !isSameSender(prevFBA, values?.by)
              ? {
                  by: values?.by,
                  time: values?.sendTime,
                }
              : prevFBA,
        };

        aux.data[pos].message.push({
          by: values?.by,
          userId: values?.userId,
          previousId: values?.previousId,
          text: values?.message?.text,
          files: values?.message?.file
            ? {
                file_name: values?.message?.file?.fileName,
                file_url:
                  values?.message?.file?.fileUrl || values?.message?.file?.data,
                thumb_url: values?.message?.file?.thumbUrl,
                mime_type: values?.message?.file?.mimeType,
              }
            : null,
          sendTime: values?.sendTime,
          sentTime: null,
          status: values?.status,
          private: values?.private,
        });

        dispatch(setMessage(aux));
      }
    }
    if (activeChat?.conversation) {
      activeChat.sendMessage.values = {
        text: "",
      };
    }
  };

  const getChat = (chatId) => {
    let chats = messageOperator?.chats;
    let index =
      chats?.data?.findIndex((c) => c?.conversationId === chatId) ?? -1;
    let chat = index >= 0 ? chats?.data[index] : null;
    return {
      index: index,
      chat: chat,
    };
  };

  // message.file
  const updateStore = (
    chatId,
    previousId,
    currentId,
    sendTime,
    sentTime,
    status,
    files,
    message
  ) => {
    if (messageOperator?.chats?.data) {
      let aux = messageOperator.chats;
      let pos = "";

      if (aux?.data) {
        pos =
          aux?.data?.length > 0
            ? aux?.data?.find((e) => e?.conversationId === chatId)
            : null;
        pos = aux?.data?.indexOf(pos);

        if (pos !== null && pos !== undefined) {
          let d1 = new Date(sendTime);
          let findMsg =
            aux?.data[pos]?.message?.length > 0
              ? aux.data[pos].message.find((e) => {
                  let d2 = new Date(e?.sendTime);
                  return d1.getTime() === d2.getTime();
                })
              : null;
          findMsg = aux?.data[pos]?.message?.indexOf(findMsg);

          if (findMsg !== -1) {
            aux.data[pos].message[findMsg] = {
              ...aux?.data[pos]?.message[findMsg],
              previousId: previousId,
              currentId: currentId,
              sendTime: sendTime,
              sentTime: sentTime,
              status: status,
              files: files || aux?.data[pos]?.message[findMsg]?.files,
              text: message ? message : aux?.data[pos]?.message[findMsg].text,
            };

            dispatch(setMessage(aux));
          }
        }
      }
    }
  };

  // TODO: improve this method
  const updateChat = (obj) => {
    isObject(obj) && dispatch(setMessage(obj));
  };

  const insertCurrentUser = (params) => {
    let user = {
      conversationId: activeChat?.conversation?.conversationId,
      user: {
        user_id: data?.user?.id,
        user_name: data?.user?.name,
        user_nickname: data?.user?.nickname,
        ...params,
      },
    };
    user?.conversationId && handleJoinedManager(user, getChat, updateChat);
  };

  // TODO: improve this method
  const updateChatImages = (id, status) => {
    let el =
      status !== "closed"
        ? messageOperator?.chats?.data?.find((e) => e.conversationId === id)
        : {
            message:
              isObject(messageConsumer?.messages) &&
              messageConsumer.messages[id],
          };
    let aux = [];

    isArray(el?.message) && el.message.length > 0
      ? el.message.forEach((msg) => {
          if (msg?.files?.mime_type.split("/")[0] === "image") {
            aux.push(msg?.files?.file_url);
          }
        })
      : aux.push("");

    aux = aux.map((src) => {
      return { src };
    });
    aux = aux?.length > 0 ? aux : null;

    setChatImages(aux);
  };

  // TODO: improve this method
  const updateTabId = (chatId, tabId) => {
    if (messageOperator?.chats?.data) {
      let aux = messageOperator.chats;
      let pos = "";

      if (aux?.data) {
        pos =
          aux?.data?.length > 0
            ? aux?.data?.find((e) => e?.conversationId === chatId)
            : null;
        pos = aux?.data?.indexOf(pos);

        if (pos !== null && pos !== undefined) {
          aux.data[pos] = {
            ...aux.data[pos],
            conversationTab: tabId,
          };
          dispatch(setMessage(aux));
        }
      }
    }
  };

  // TODO: check this method. There is an error here probably, deleting from buffer before attempt
  const updateSendBuffer = () => {
    if (sendBuffer.length > 0) {
      // aux.shift();
      sendBuffer.shift();
      // setSendBuffer(() => aux);
    }
  };

  const processSendBuffer = () => {
    if (sendBuffer.length > 0) {
      let limitAttempts = 3;
      let values = getMsgFromBuffer(0);

      if (values?.countAttempts < limitAttempts) {
        if (!messageOperator?.status?.upload_file?.sending) {
          if (values?.message?.file && !values?.message?.file?.uploaded) {
            let formData = new FormData();
            let data = null;

            formData.append(
              `file-${values?.sendTime?.getTime()}`,
              values?.message?.file?.formData,
              values?.message?.file?.fileName
            );
            data = {
              chatId: values?.chatId,
              formData: formData,
              sendTime: values?.sendTime,
            };
            dispatch(uploadFile(data));
          } else if (
            !values?.message?.file ||
            (values?.message?.file && values?.message?.file?.uploaded)
          ) {
            let data = {
              chatId: values?.chatId,
              date: values?.sendTime,
              message: {},
            };

            if (values?.message?.text)
              data.message.text = values?.message?.text;
            if (values?.message?.file?.id)
              data.message.fileId = values?.message?.file?.id;
            if (values?.message?.by_manager) data.message.by_manager = true;

            dispatch(sendMessage(data, values?.private));
          }
        }
      } else {
        updateStore(
          values?.chatId,
          values?.previousId,
          null,
          values?.sendTime,
          Date.now(),
          {
            sending: false,
            sent: false,
            delivered: null,
            read: null,
            error: true,
          }
        );

        // retry limit reached
        updateSendBuffer();
      }
    }
  };

  const handleMsgSubmit = (msg) => {
    if (
      activeChat?.sendMessage?.values?.text !== "" ||
      activeChat?.sendMessage?.values?.file !== undefined ||
      msg
    ) {
      if (spyConversation) activeChat.sendMessage.values.by_manager = true;

      let lastPrevId =
        activeChat?.conversation?.message[
          activeChat.conversation.message?.length - 1
        ]?.currentId;

      setSendBuffer(() => [
        ...sendBuffer,
        {
          by: spyConversation ? "manager" : "agent",
          private: msg?.private ?? false,
          chatId: activeChat?.conversation?.conversationId,
          previousId: lastPrevId,
          userId: data?.user?.id,
          values: msg?.values ?? activeChat?.sendMessage?.values,
          sendTime: new Date(),
          sentTime: null,
          countAttempts: 0,
          status: {
            sending: true,
            sent: null,
            delivered: null,
            read: null,
            error: null,
          },
          token: data?.Authorization ?? null,
        },
      ]);

      setScrollToBottom(true);
    }
  };

  const collapse = () => {
    dispatch(chatCollapsing());
    const body = document.body;
    body.classList.remove("no-scroll");
  };

  const handleSearch = (search) => {
    let chatList = null;
    let isSearching = false;

    if (search !== "") {
      search = search.replace(/\\/g, "\\\\");
      let regex = new RegExp(search, "i");

      chatList = [];

      if (messageOperator?.chats?.data) {
        messageOperator.chats.data.forEach((chat) => {
          let id = chat?.consumer?.name?.match(regex)
            ? chat?.conversationId
            : chat?.message?.length > 0
            ? chat?.message?.find((el) => el?.text?.match(regex))
              ? chat?.conversationId
              : []
            : chat?.lastMessage?.text?.match(regex)
            ? chat?.conversationId
            : [];

          if (chat?.conversationId === id) chatList.push(chat?.conversationId);
        });
      }

      chatList = chatList.length > 0 ? chatList : null;

      isSearching = true;
    }

    setSearchChat(() => ({
      isSearching: isSearching,
      chats: chatList,
    }));
  };

  const handleReconnected = (fromCheckConversation) => {
    let objAlert = {};
    if (fromCheckConversation) {
      objAlert = {
        title: t("New messages for you!"),
        text: t(
          "Wait a moment while we make it available on your attendance list"
        ),
      };
    } else {
      objAlert = {
        title: t("Reloading chats"),
        text: t(
          "There was a loss of connection, but we are already solving it. Wait a minute..."
        ),
      };
    }
    setLoadingReconnect(objAlert);
    dispatch(resetObj());
    if (spyConversation) {
      dispatch(startObserver(spyConversation));
    } else {
      dispatch(getMessages());
    }
  };

  const retry = useRef(0);
  const routineCheckConversation = useCallback(async () => {
    try {
      const response = await axios.post(`/conversations-check`, {
        conversations: messageOperator?.chats?.data
          ?.filter((e) => e.status === "active" || e.status === "inactive")
          .map((e) => e.conversationId),
      });
      if (response.status !== 200) throw response.data;
      if (!response?.data?.data?.isOk) throw response.data;
      else retry.current = 0;
    } catch (error) {
      if (retry.current < 3) retry.current += 1;
      else {
        handleReconnected();
        retry.current = 0;
      }
    }
  }, [messageOperator?.chats?.data, handleReconnected]);

  const handleDisconnect = () => {
    setLoadingReconnect({
      title: t("Communication failure"),
      text: t(
        "Hello, there was a communication failure between the Tech platform and your machine. Please refresh the page"
      ),
    });
    dispatch(resetObj());
  };

  useEffect(() => {
    if (connSignalR?.connection === "failed") {
      handleDisconnect();
    }
  }, [connSignalR?.connection]);

  useTimeoutEffect(
    useCallback(() => {
      dispatch(getMessages());
    }, [dispatch]),
    useMemo(() => {
      const now = new Date();
      return dateFns.differenceInMilliseconds(dateFns.endOfDay(now), now);
    }, [])
  );

  const checkMsgs = async () => {
    const isOk = await messagesCheck(messageOperator?.chats);
    if (!isOk) {
      dispatch(resetObj());
      if (spyConversation) {
        dispatch(startObserver(spyConversation));
      } else {
        dispatch(getMessages());
      }
    }
  };

  const toggleTransfChat = () => {
    setTransfChat(!transfChat);
    setActionType("transferChat");
  };
  const toggleCloseChat = () => {
    setCloseChat(!closeChat);
    setActionType("closeChat");
  };
  const toggleTabChat = () => {
    setTabChat(!tabChat);
    setNotes(false);
    setActionType("tab");
  };
  const toggleTabTicket = () => {
    setTabChat(!tabChat);
    setNotes(true);
    setActionType("tab");
  };
  const toggleTabCommentary = useCallback(() => {
    setTabChat(false);
    setNotes(false);
    setCommentaryMsg((commentaryMsg) => !commentaryMsg);
    setActionType("createCommentary");
  }, []);
  const togglePrivateMsg = () => {
    setPrivateMsg(!privateMsg);
    setActionType("privateMsg");
  };
  const toggleCreateAttendance = () => {
    setCreateAttendance((prev) => !prev);
    setActionType("createAttendance");
  };

  const onSubmitChatTransfer = useCallback(
    (e) => {
      if (typeof e.message === "string" && e.body) {
        const msg = [];

        if (e?.body?.skillsInExceptions || e?.body?.skillsNotInWorkScheludes) {
          toggleTransfChat();
          let date = null;
          try {
            date = dateFns.format(
              new Date(e?.body?.nextOnDate),
              "dd/MM/yyyy HH:mm"
            );
            date = date.split(" ");
            date = `${date[0]} - ${date[1]}`;
          } catch (error) {}

          const text = `${t(
            `The call cannot be transferred as the selected skill is out of call hours and will return on`
          )} ${date}`;
          msg.push(text);
        } else if (e?.body?.hasUsersOnline === false) {
          toggleTransfChat();
          msg.push(
            t(
              `The call cannot be transferred because there are no operators logged into this skill`
            )
          );
        }

        setMessagesErrors(msg);
        handleClickOpenModalRequest();
      } else {
        handleTransferChat(e, spyConversation, resetActiveChat, t);
      }
    },
    [handleTransferChat, spyConversation, resetActiveChat, t]
  );

  const getUnreadMessages = () => {
    if (Object.keys(messagesSignalR).length > 0) {
      return messagesSignalR;
    }
  };

  const clickSpyChat = () => {
    let currentChat = document.getElementById(`chat-${spyConversation}`);
    if (currentChat) currentChat.click();
  };

  const clickClosedFilter = () => {
    if (spyConversation) {
      let closedButton = document.getElementById("filterClosedButton");
      let chat = messageOperator?.chats?.data?.find(
        (e) => e?.conversationId === spyConversation
      );

      if (chat?.status === "closed" || chat?.status === "pos-chat")
        setTimeout(() => {
          closedButton.click();
        }, 1000);
    }
  };

  const handleClickConversation = useCallback(
    (conversation, event, { obj }) => {
      updateChatImages(conversation?.conversationId, conversation?.status);

      // Saving client data for sending files

      dispatch(
        setCurrentChatData(
          conversation?.conversationId,
          conversation?.conversationTab,
          conversation?.consumer?.id
        )
      );

      setSkillIdToShowMsg(conversation?.skillId);

      setshowChat(!showChat);

      if (
        activeChat?.conversation?.conversationId ===
        conversation?.conversationId
      ) {
        setActiveChat(() => ({
          sendMessage: {
            ...activeChat.sendMessage,
            values: {
              text: "",
            },
          },
        }));
        if (hideEngagementHistory) {
          setEngagementHistory(false);
        }
      } else {
        let chats =
          messageOperator &&
          messageOperator.chats &&
          messageOperator.chats.data;

        let historyChats =
          messageConsumer &&
          messageConsumer.chats &&
          messageConsumer.chats.data;

        // get consumer messages
        if (
          !historyChats ||
          (historyChats && !historyChats[conversation.consumer.id])
        ) {
          dispatch(
            getConsumerConversations(
              conversation?.consumer?.id,
              conversation?.channel
            )
          );
        }

        let aux =
          chats &&
          chats.find(
            (chat) => chat.conversationId === conversation.conversationId
          );

        let selected = {
          ...conversation,
          message: aux?.message ?? [],
        };

        setActiveChat(() => ({
          ...activeChat,
          conversation: selected,
          sendMessage: {
            ...activeChat.sendMessage,
            values: {
              text: "",
            },
          },
        }));

        if (hideEngagementHistory) {
          setEngagementHistory(false);
        }
      }
    },
    [
      activeChat,
      dispatch,
      hideEngagementHistory,
      messageConsumer,
      messageOperator,
      showChat,
      updateChatImages,
    ]
  );

  useEffect(() => {
    dispatch(getFlashMsgs());
    dispatch(changeHeaderName("Agent area"));
    dispatch(getCsat());
    dispatch(getNps());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (spyConversationId) {
        dispatch(vgRemoveMessage(spyConversationId));
        dispatch(closeObserver(spyConversationId));
        dispatch(resetObj());
      }
    };
  }, []);

  useEffect(() => {
    let loadMessages = false;
    if (connSignalR && connSignalR.data && connSignalR.status === "Connected") {
      // Just start signalR methods if previous messages were loaded
      checkMessages(
        connSignalR.data,
        buffer,
        setBuffer,
        handleNewMessageQueue,
        handleNewMessageTelegram,
        handleNewMessageFromAgent,
        handleNewMessageFromManager,
        handleNewMessagePrivate,
        setClosedByClient,
        setClosedByAgent,
        setClosedByManager,
        setClosedBySystem,
        setTransferedByManager,
        setTransferedBySystem,
        setTransferedByAgent,
        setInactiveBySystem,
        setJoinedManager,
        setEndPreChat,
        setEndPosChat,
        setReopenConversation,
        setReconnecting,
        history,
        spyConversationId,
        handleReconnected
      ); // To ensure that this is called only once (VG_STARTED_SIGNALR_CONN)
      loadMessages = true;
      setLoadingReconnect(false);
    }
    if (connSignalR && connSignalR.error) {
      loadMessages = true;
    }
    if (loadMessages) {
      dispatch(resetObj());
      if (spyConversationId) {
        dispatch(resetClientInfo(spyConversationId));
        dispatch(startObserver(spyConversationId));
      } else {
        dispatch(getMessages());
      }
    }
  }, [connSignalR, spyConversationId]);

  useEffect(() => {
    let interval = null;
    if (messageOperator?.chats?.data) {
      if (!spyConversation) {
        interval = setInterval(routineCheckConversation, 10000);
      }
      if (activeChat?.conversation?.conversationId) {
        updateChatImages(
          activeChat?.conversation?.conversationId,
          activeChat?.conversation?.status
        );
      }
    } else {
      if (messageOperator.status?.get_messages?.error) {
        !loadingReconnect && handleReconnected();
      }
    }

    if (messageOperator?.status?.get_messages) {
      if (messageOperator.status.get_messages?.success) {
        connSignalR?.connection !== "failed" && setLoadingReconnect(false);
        dispatch(resetStatus("get_messages"));
        Array.isArray(messageOperator.chats.data) &&
          !triggerSLA &&
          setTriggerSLA(true);
        clickClosedFilter();
      }
      if (messageOperator.status.get_messages?.error) {
        // setLoadingReconnect(false);
      }
    }
    if (messageOperator?.status?.agent_inactivity) {
      if (messageOperator?.status?.agent_inactivity?.loading) {
      } else if (messageOperator?.status?.agent_inactivity?.success?.status) {
        // dispatch(resetStatus("agent_inactivity"));
      }
    }

    if (messageOperator?.status?.upload_file) {
      let upload_file = messageOperator.status.upload_file;
      if (upload_file?.success?.status) {
        if (sendBuffer[0]) {
          sendBuffer[0] = {
            ...sendBuffer[0],
            values: {
              ...sendBuffer[0].values,
              file: {
                ...sendBuffer[0].values?.file,
                uploaded: true,
                id: upload_file?.success?.fileId,
                sendTime: upload_file?.success?.sendTime,
              },
            },
            countAttempts: 0,
          };
        }
        dispatch(resetStatus("upload_file"));
        processSendBuffer();
      } else if (upload_file?.error?.status) {
        if (sendBuffer[0]) {
          sendBuffer[0] = {
            ...sendBuffer[0],
            countAttempts: sendBuffer[0]?.countAttempts + 1,
          };
        }
        setTimeout(() => processSendBuffer(), 500);
        dispatch(resetStatus("upload_file"));
      }
    }

    if (messageOperator?.status?.send_message) {
      let send_message = messageOperator.status.send_message;
      if (send_message?.success?.status) {
        updateStore(
          send_message?.success?.chatId,
          send_message?.success?.previousId,
          send_message?.success?.currentId,
          send_message?.success?.sendTime,
          send_message?.success?.sentTime,
          send_message?.success?.status,
          send_message?.success?.files,
          send_message?.success?.message
        );
        updateSendBuffer();
        dispatch(resetStatus("send_message"));
        processSendBuffer();
      } else if (send_message?.error?.status) {
        if (sendBuffer[0]) {
          sendBuffer[0] = {
            ...sendBuffer[0],
            countAttempts: sendBuffer[0]?.countAttempts + 1,
          };
        }
        setTimeout(() => processSendBuffer(), 500);
        dispatch(resetStatus("send_message"));
      }
    }

    if (messageOperator?.status?.get_message) {
      let get_message = messageOperator.status.get_message;
      if (get_message?.success) {
        let aux = buffer.queue;
        if (aux.length > 0) {
          //CLEAR BUFFER
          aux.shift();
        }
        dispatch(resetStatus("get_message"));
      }
    }

    if (messageOperator?.status?.close_chat) {
      let close_chat = messageOperator?.status?.close_chat;

      if (close_chat?.success) {
        updateChangeStatus(
          close_chat?.success?.chatId,
          close_chat?.success?.chatStatus,
          messageOperator,
          dispatch,
          setMessage
        );
        updateTabId(
          activeChat?.conversation?.conversationId,
          close_chat?.success?.tabId
        );
        resetActiveChat();
        if (!spyConversation) showToast("success", t("Chat closed"));
        setCloseChat(false);
        setTabChat(false);
        setNotes(false);

        dispatch(resetStatus("close_chat"));
        dispatch(resetClientInfo(close_chat?.success?.chatId));
        dispatch(removeScrollMessage(close_chat?.success?.chatId));
      } else if (close_chat && close_chat.error.status) {
        dispatch(resetStatus("close_chat"));
        if (!spyConversation)
          showToast(
            "error",
            t(
              close_chat.error.message?.[0].value ||
                "Failed to update conversation status"
            )
          );
        setCloseChat(false);
        setTabChat(false);
        setNotes(false);
      }
    }

    if (messageOperator?.status?.tabulate_chat) {
      let tabulate_chat = messageOperator?.status?.tabulate_chat;
      if (tabulate_chat?.success) {
        updateTabId(
          activeChat?.conversation?.conversationId,
          tabulate_chat?.success?.tabId
        );
        setActiveChat(() => ({
          ...activeChat,
          conversation: {
            ...activeChat?.conversation,
            conversationTab: tabulate_chat?.success?.tabId,
          },
        }));
        showToast("success", t("Tab added"));
        setCloseChat(false);
        setTabChat(false);
        setNotes(false);

        dispatch(resetStatus("tabulate_chat"));
        dispatch(resetClientInfo(tabulate_chat?.success?.chatId));
        if (
          messageOperator?.data?.type === "real_automation" &&
          !tabulate_chat?.success?.infoTab
        ) {
          resetActiveChat();
        }
      } else if (tabulate_chat && tabulate_chat.error.status) {
        dispatch(resetStatus("tabulate_chat"));

        toastr.error(
          t(tabulate_chat.error.message ?? "Failed to tab conversation"),
          undefined,
          { timeOut: 8000 }
        );

        setCloseChat(false);
        setTabChat(false);
        setNotes(false);
      }
    }

    if (messageOperator?.status?.disable_chat) {
      let disable_chat = messageOperator.status.disable_chat;
      if (disable_chat?.success) {
        let chat = chats?.find(
          (e) => e?.conversationId === disable_chat.success?.chatId
        );
        let event = chat?.events?.disableChat;

        if (event) event.countAttempts = 0;

        updateChangeStatus(
          disable_chat.success?.chatId,
          disable_chat.success?.chatStatus,
          messageOperator,
          dispatch,
          setMessage
        );
        dispatch(resetStatus("disable_chat"));
      }
    }
    return () => clearInterval(interval);
  }, [messageOperator]);

  useEffect(() => {
    let get_messages = messageConsumer?.status?.get_messages;
    if (get_messages?.success?.status || get_messages?.error?.status) {
      dispatch(resetConsumerStatus("get_messages"));
    }
  }, [messageConsumer?.status]);

  useEffect(() => {
    if (timer) handleTimer(messageOperator, setChats);
  }, [timer]);

  useEffect(() => {
    if (triggerSLA) {
      let interval = null;
      interval = setInterval(() => setTimer(new Date()), 1000);
      return () => clearInterval(interval);
    }
  }, [triggerSLA]);

  useEffect(() => {
    // Loop through array. While queue has data, run cron
    if (buffer.queue && buffer.queue.length > 0) {
      const chatBuffer = buffer?.queue[0];

      if (messageOperator?.chats?.data) {
        const bufferMsg = chatBuffer?.message;
        const aux = messageOperator.chats;
        const pos = aux.data.findIndex(
          (e) => e.conversationId === chatBuffer?.conversationId
        );

        if (chatBuffer?.type === "new" && !spyConversation) {
          // TODO: call dispatch to change message status (new => active)
          //If to prevent duplicate chats
          if (pos >= 0) {
            //CLEAR BUFFER
            buffer.queue.shift();
          } else {
            let unread = bufferMsg?.length;

            // TODO: change files atribute to snake case (to match with new api version)
            aux.data.push({
              channel: chatBuffer.channel,
              start: chatBuffer.start,
              assignedTime: chatBuffer.assignedTime,
              status: chatBuffer.status,
              conversationId: chatBuffer.conversationId,
              conversationTab: chatBuffer?.conversationTab,
              skillId: chatBuffer.skillId,
              isAiSummaryEnabled: chatBuffer.isAiSummaryEnabled,
              slaLate: chatBuffer.slaLate,
              inactivityTime: chatBuffer.inactivityTime,
              unreadMessages: unread,
              users: chatBuffer.users,
              supportedFiles: chatBuffer.supportedFiles,
              ticket: chatBuffer.ticket,
              lastMessage: {
                by: chatBuffer.lastMessage?.by,
                time: chatBuffer.lastMessage?.time,
                text: chatBuffer.lastMessage?.text,
                files: {
                  fileName: chatBuffer.lastMessage?.files?.file_name,
                  fileUrl: chatBuffer.lastMessage?.files?.file_url,
                  thumbUrl: chatBuffer.lastMessage?.files?.file_name,
                  mimeType: chatBuffer.lastMessage?.files?.mime_type,
                },
              },
              consumer: chatBuffer.consumer,

              // TODO: update this method
              firstWithoutAnswer: {
                by:
                  findLast(bufferMsg, isValidMsg)?.by ??
                  defaultMsg(chatBuffer)?.by,
                time: chatBuffer.assignedTime,
              },
              events: {
                disableChat: {
                  limitAttempts: 3,
                  countAttempts: 0,
                },
                agentInactivity: {
                  limitAttempts: 3,
                  countAttempts: 0,
                },
              },
              // message: bufferMsg[0]],
              message: [],
              slaCount: chatBuffer.slaCount,
              usefulTimeCounter: chatBuffer.usefulTimeCounter,
              pullAt: new Date(),
              createdAt: chatBuffer.createdAt,
            });

            let key = 0;

            bufferMsg.forEach(() => {
              aux.data[aux.data.length - 1].message.push({
                ...bufferMsg[key], // temporary: waiting for backend fix payload. After that, below attributes won"t be rewritten
                by: bufferMsg[key]?.by ?? chatBuffer?.by,
                systemMessage: bufferMsg[key]?.systemMessage,
                userId: bufferMsg[key].userId,
                text: bufferMsg[key].text,
                sentTime: bufferMsg[key].sentTime,
                files: bufferMsg[key].files
                  ? {
                      file_name: bufferMsg[key].files.file_name ?? null,
                      file_url: bufferMsg[key].files.file_url ?? null,
                      thumb_url: bufferMsg[key].files.thumb_url ?? null,
                      mime_type: bufferMsg[key].files.mime_type ?? null,
                    }
                  : null,
              });
              key++;
            });

            dispatch(setMessage(aux));
          }
        } else {
          // Conversation already exists in the store. So, just insert it
          if (pos >= 0) {
            // Add message if conversation isn"t closed
            if (aux.data[pos]?.status !== "closed") {
              let prevFBA = aux.data[pos]?.firstWithoutAnswer; // "First Before Answer" object previously stored

              // Get unreadMessages
              let unreadAll = getUnreadMessages() ?? {};
              let unread =
                objLength(unreadAll) > 0 &&
                unreadAll[chatBuffer?.conversationId]?.length;

              let hasPrevUnread = aux.data[pos]?.message?.some((e) =>
                e?.hasOwnProperty("unreadMsg")
              );

              // Add unread msg
              if (!hasPrevUnread) {
                aux.data[pos].message.push({
                  userId: null,
                  text: null,
                  sentTime: new Date(),
                  files: null,
                  unreadMsg: true,
                  private: true, // temporary flag until refactor unreadMsgs control, without insert into array
                });
              }

              // Add new user received in private msg socket
              if (chatBuffer?.user) {
                aux.data[pos]?.users?.push(chatBuffer.user);
              }

              // TODO: Temporary code. Waiting for backend update atributtes
              if (!bufferMsg[0]?.by) {
                bufferMsg[0].by = chatBuffer?.by;
              }

              aux.data[pos].message.push(bufferMsg[0]);

              aux.data[pos] = {
                ...aux.data[pos],
                status:
                  chatBuffer?.by === "consumer" &&
                  aux.data[pos]?.status !== "pos-chat"
                    ? "active"
                    : aux.data[pos]?.status,
                unreadMessages: unread,
                lastMessage: {
                  by: bufferMsg[0]?.by,
                  time: bufferMsg[0]?.sentTime,
                  text: bufferMsg[0]?.text,
                  location: bufferMsg[0]?.location,
                  files: bufferMsg[0]?.files
                    ? {
                        fileName: bufferMsg[0]?.files?.file_name || null,
                        fileUrl: bufferMsg[0]?.files?.file_url || null,
                        thumbUrl: bufferMsg[0]?.files?.file_name || null,
                        mimeType: bufferMsg[0]?.files?.mime_type || null,
                      }
                    : null,
                  private: bufferMsg[0]?.private,
                },
                firstWithoutAnswer:
                  !isPrivateMsg(bufferMsg[0]) &&
                  isAllowedUserMsg(bufferMsg[0]) &&
                  !isSameSender(prevFBA, bufferMsg[0]?.by)
                    ? {
                        by: bufferMsg[0]?.by,
                        time: bufferMsg[0]?.sentTime,
                      }
                    : prevFBA,

                events: {
                  disableChat: {
                    limitAttempts: 3,
                    countAttempts: 0,
                  },
                  agentInactivity: {
                    limitAttempts: 3,
                    countAttempts: 0,
                  },
                },
              };
              dispatch(setMessage(aux));
            } else {
              //CLEAR BUFFER
              buffer.queue.shift();
            }
          } else {
            if (!spyConversationId) {
              dispatch(resetObj());
              dispatch(getMessages());
            }
          }
        }
      } else {
        if (chatBuffer?.type !== "new") {
          dispatch(resetObj());
          if (spyConversationId) {
            dispatch(resetClientInfo(spyConversationId));
            dispatch(startObserver(spyConversationId));
          } else {
            dispatch(getMessages());
          }
        }
      }
    }
  }, [buffer]);

  useEffect(() => {
    if (sendBuffer.length > 0) {
      addMessage();
    }
    //TODO: #REF001 - Removed the internet validation. After changes needed remove coments
    //and delete the processSendBuffer, because is used on the handleConnection
    //checkInternet(handleConnection, setHandleConnection);
    if (
      !messageOperator?.status?.send_message?.loading &&
      !messageOperator?.status?.upload_file?.loading
    ) {
      processSendBuffer();
    }
  }, [sendBuffer]);

  useEffect(() => {
    handleFilter(
      chats,
      getChat,
      spyConversation,
      messageOperator,
      queueFilter,
      setQueueFilter,
      indicators,
      dispatch,
      getCsat,
      getNps,
      setHeaderIndicators
    );
  }, [chats]);

  useEffect(() => {
    // TODO: check if this is the better way to update the chatImagesMethod
    if (messageConsumer?.chats?.data) {
      if (activeChat?.conversation?.conversationId) {
        updateChatImages(
          activeChat?.conversation?.conversationId,
          activeChat?.conversation?.status
        );
      }
    }
  }, [messageConsumer]);

  useEffect(
    () =>
      handleClosedByClient(
        closedByClient,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [closedByClient]
  );
  useEffect(
    () =>
      handleClosedByAgent(
        closedByAgent,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [closedByAgent]
  );
  useEffect(
    () =>
      handleClosedByManager(
        closedByManager,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [closedByManager]
  );
  useEffect(
    () =>
      handleClosedBySystem(
        closedBySystem,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [closedBySystem]
  );

  useEffect(
    () =>
      handleTransferedByAgent(
        transferedByAgent,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [transferedByAgent]
  );
  useEffect(
    () =>
      handleTransferedByManager(
        transferedByManager,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [transferedByManager]
  );
  useEffect(
    () =>
      handleTransferedBySystem(
        transferedBySystem,
        activeChat,
        resetActiveChat,
        spyConversation,
        t
      ),
    [transferedBySystem]
  );

  useEffect(() => handleInactiveBySystem(inactiveBySystem), [inactiveBySystem]);
  useEffect(
    () => handleJoinedManager(joinedManager, getChat, updateChat),
    [joinedManager]
  );

  useEffect(() => handleEndPreChat(endPreChat), [endPreChat]);
  useEffect(() => handleEndPosChat(endPosChat), [endPosChat]);

  useEffect(() => {
    if (reopenConversation) {
      dispatch(
        reopenConversationRes(
          { data: reopenConversation, loading: false, success: "reopenGet" },
          "reopenGet"
        )
      );
    }
  }, [reopenConversation]);

  useEffect(() => {
    if (reconnecting) {
      checkMsgs();
    }
  }, [reconnecting]);

  useEffect(() => {
    // TODO: find a better solution to this
    if (scrollToBottom) setScrollToBottom(false);
  }, [scrollToBottom]);

  useEffect(() => {
    // Hide private message component with there"s no active chat opened
    !activeChat?.conversation?.conversationId &&
      privateMsg &&
      setPrivateMsg(false);
  }, [activeChat?.conversation?.conversationId]);

  useEffect(() => {
    if (!spyConversationId && spyConversation) {
      dispatch(vgRemoveMessage(spyConversation));
      dispatch(closeObserver(spyConversation));
      dispatch(resetObj());
    }

    setSpyConversation(spyConversationId);
  }, [spyConversationId]);

  useEffect(() => {
    if (notificationChatId) {
      setActiveChatByChatId(
        notificationChatId,
        messageOperator,
        setActiveChat,
        activeChat
      );
      dispatch(vgRemoveMessage(notificationChatId));
    }
  }, [notificationChatId]);

  // TODO: improve this method
  useEffect(() => {
    clickSpyChat();
  }, [document.getElementById(`chat-${spyConversation}`)]);

  if (activeChat?.conversation?.conversationId) {
    document.onkeydown = (e) => {
      if (e.altKey) {
        if (e.key === "c") {
          if (
            activeChat.conversation.status !== "closed" &&
            activeChat?.conversation?.channel !== "real_automation"
          ) {
            !transfChat && !tabChat && !privateMsg && toggleCloseChat(true);
          }
        }
        if (e.key === "t") {
          
          if (activeChat.conversation.status !== "closed") {
            !closeChat && !tabChat && !privateMsg && toggleTransfChat(true);
          }
        }
        if (e.key === "i") {

          if (activeChat?.conversation?.channel === "real_automation" &&
             activeChat.conversation.status !== "closed") {
            !closeChat && !transfChat && !privateMsg && toggleTabTicket(true);
          }

          if (
            activeChat.conversation.status !== "closed" &&
            objFeatureTab?.active &&
            activeChat?.conversation?.channel !== "real_automation"
          ) {
            !closeChat && !transfChat && !privateMsg && toggleTabChat(true);
          }

        }
        if (e.key === "p") {
          if (activeChat.conversation.status !== "closed") {
            !closeChat && !transfChat && !tabChat && togglePrivateMsg(true);
          }
        }
        if (e.key === "x") {
          !closeChat &&
            !transfChat &&
            !tabChat &&
            !privateMsg &&
            !commentaryMsg &&
            conversationDownload();
        }
        if (e.key === "m") {
          !closeChat &&
            !transfChat &&
            !tabChat &&
            !privateMsg &&
            !commentaryMsg &&
            toggleTabCommentary();
        }
      }
      if (e.key === "Escape") {
        setCloseChat(false);
        setTransfChat(false);
        setTabChat(false);
        setNotes(false);
        setPrivateMsg(false);
      }
    };
  }

  return (
    <>
      <Container fluid className="page-content vh-100 pb-3">
        <Row className="h-100 w-100 flex-nowrap overflow-hidden">
          {/* QueueConversations Container */}
          <Row
            className="h-100 flex-nowrap ml-2"
            style={{
              minWidth:
                activeChat?.conversation?.channel !== "telefone"
                  ? "805px"
                  : "0px",
            }}
          >
            {/* QueueAttendance */}
            <Col
              style={{
                maxWidth: "340px",
                minWidth: "340px",
              }}
              className="d-flex flex-column"
            >
              <QueueAttendance
                overdue={queueFilter.overdue.qtd}
                progress={queueFilter.progress.qtd}
                inactive={queueFilter.inactive.qtd}
                closed={queueFilter.closed.qtd}
                onChangeFilter={(e) =>
                  setQueueFilter(() => ({
                    overdue: { ...queueFilter.overdue, active: e.overdue },
                    progress: { ...queueFilter.progress, active: e.progress },
                    inactive: { ...queueFilter.inactive, active: e.inactive },
                    closed: { ...queueFilter.closed, active: e.closed },
                  }))
                }
                update={chats.length}
                onChangeSearch={(e) => handleSearch(e.target.value)}
                isSpy={!!spyConversationId}
                resetActiveChat={resetActiveChat}
              />
              <div style={{ overflow: "auto" }} className="flex-grow-1">
                <PerfectScrollbar>
                  <TabContent activeTab="1">
                    <TabPane tabId="1">
                      <ChatList
                        activeChat={activeChat}
                        setActiveChat={setActiveChat}
                        chats={chats}
                        getChat={getChat}
                        messageOperator={messageOperator}
                        onConversationClick={handleClickConversation}
                        search={searchChat}
                        showConversation={showConversation}
                      />
                    </TabPane>
                    {spyConversation && (
                      <p className="text-center mt-3">
                        {t("Viewing conversations in spy mode")}
                      </p>
                    )}
                  </TabContent>
                </PerfectScrollbar>
                {permissionsExtra?.["phone"] && !spyConversation && (
                  <div
                    className="create-attendance-float-button"
                    onClick={() => {
                      setCreateAttendance(true);
                    }}
                  >
                    <i className="bx bx-chat" />
                  </div>
                )}
              </div>
              {spyConversation && !isSpyOperator && (
                <div className="text-left">
                  <Button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light w-100"
                    onClick={() => {
                      history.push("/manager-panel");
                    }}
                  >
                    <i className="mdi mdi-arrow-left font-size-13 mr-2"></i>
                    {t("Back to Manager Panel")}
                  </Button>
                </div>
              )}
            </Col>
            {/* Conversations */}

            {showTicketsOperatorArea && !spyConversationId ? (
              <TicketsOperatorArea />
            ) : (
              <AttendanceComponent
                activeChat={activeChat}
                setActiveChat={setActiveChat}
                hideEngagementHistory={hideEngagementHistory}
                getChat={getChat}
                updateChat={updateChat}
                chats={chats}
                messageOperator={messageOperator}
                onConversationClick={handleClickConversation}
                search={searchChat}
                showConversation={showConversation}
                chatImages={chatImages}
                toggleTabChat={toggleTabChat}
                toggleTransfChat={toggleTransfChat}
                toggleCloseChat={toggleCloseChat}
                togglePrivateMsg={togglePrivateMsg}
                conversationDownload={conversationDownload}
                spyConversation={spyConversation}
                handleMsgSubmit={handleMsgSubmit}
                insertCurrentUser={insertCurrentUser}
                toggleTabTicket={toggleTabTicket}
                toggleTabCommentary={toggleTabCommentary}
                scrollToBottom={scrollToBottom}
                updateEngagement={updateEngagement}
                endPosChat={endPosChat}
                skillIdToShowMsg={skillIdToShowMsg}
                showChat={showChat}
                engagementHistory={engagementHistory}
                setEngagementHistory={setEngagementHistory}
                agentSpy={spyConversation && isSpyOperator}
              />
            )}
          </Row>
        </Row>
      </Container>

      {/* TODO: group moreOption components */}
      <CloseChat
        isOpen={closeChat}
        toggle={toggleCloseChat}
        activeChat={activeChat}
        isByManager={spyConversation ? true : false}
        actionType={actionType}
        isDisplayTabs={objFeatureTab?.active}
        isTabsRequired={objFeatureTab?.required}
        onSubmit={(e) => {
          !e?.error && setUpdateEngagement(new Date());
        }}
      />
      <CloseChat
        isOpen={tabChat}
        toggle={toggleTabChat}
        activeChat={activeChat}
        isByManager={spyConversation ? true : false}
        actionType={actionType}
        notes={notes}
        isDisplayTabs={objFeatureTab?.active}
        isTabsRequired={objFeatureTab?.required}
        isTicket={activeChat?.conversation?.channel === "real_automation"}
      />
      <PrivateMessage
        isOpen={privateMsg}
        toggle={togglePrivateMsg}
        onSubmit={(message) => {
          if (activeChat?.conversation?.conversationId) {
            let msg = {
              private: true,
              values: {
                by_manager: spyConversation ? true : false,
                text: message,
              },
            };
            let params = { joined: false };

            insertCurrentUser(params);
            handleMsgSubmit(msg);
          }
        }}
      />

      <CommentaryMessageModal
        isOpen={commentaryMsg}
        chatId={activeChat?.conversation?.conversationId}
        onCloseModalRequest={toggleTabCommentary}
      />

      <ChatTransfer
        isOpen={transfChat}
        toggle={toggleTransfChat}
        conversationId={
          activeChat &&
          activeChat.conversation &&
          activeChat.conversation.conversationId
        }
        onSubmit={onSubmitChatTransfer}
        isByManager={spyConversation ? true : false}
      />

      <TransferToSkillErroModel
        title={t(`Transfer unavailable`)}
        msg={messagesErros}
        isOpen={showModalErros}
        handleClickCloseModalRequest={handleClickCloseModalRequest}
      />

      <ActionNotAllowedModel
        msg={t("Action not allowed")}
        isOpen={blockedAction}
        handleClickCloseModalRequest={toggleBlockedAction}
        backdrop={true}
      />

      {!spyConversation && (
        <CreateAttendance
          isOpen={createAttendance}
          toggle={toggleCreateAttendance}
          conversationId={activeChat}
        />
      )}

      <DisconnectAlert
        isOpen={!!loadingReconnect}
        title={loadingReconnect?.title}
        text={loadingReconnect?.text}
        showRefreshButton={connSignalR?.connection === "failed"}
      />

      <div
        onClick={collapse}
        className={chatExpanded ? "exp-background" : ""}
      ></div>
    </>
  );
};

export default withTranslation()(memo(OperatorArea));
